import React, { FC, useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import SectionSliderCollections from "components/SectionSliderLargeProduct";
import SectionPromo1 from "components/SectionPromo1";
import ProductCard from "components/ProductCard";
import ProductCardNew from "components/ProductCardNew";
import { PRODUCTS } from "data/data";
import SidebarFilters from "./SidebarFilters";
import Pagination from "shared/Pagination/PaginationNew";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Categories, GetCleaningType, GetCleaningTypeContract, getAllProducts, getContracts, getJobs } from "Services/API/Get";
import _ from 'lodash';
import LoadingSpinner from "shared/LoadingSpinner";
import ContractCard from "components/CardCategories/ContractCard";
import ModalJob from "components/ModalJob";
import Select from "shared/Select/Select";
import Input from "shared/Input/Input";
import TabFilters from "./TabFiltersNew";
import { NavLink, useHistory } from "react-router-dom";
import AuthContext from "Context/AuthContext";
import ModalQuickView from "components/ModalContract";
import { addToast } from "shared/Toast";
import { Tooltip, Zoom } from "@mui/material";

export interface PageCollection2Props {
  className?: string;
}


const PageCollection2: FC<PageCollection2Props> = ({ className = "" }) => {

  var history = useHistory();

  const { user, setUser } = useContext(AuthContext);

  const [nProducts, setnProducts] = useState([]);
  const [allSizes, setallSizes] = useState<any | null>([]);
  const [allColours, setallColours] = useState<any | null>([]);
  const [allSubs, setallSubs] = useState<any | null>([]);
  const [categories, setcategories] = useState([]);
  const [tags, settags] = useState<any | null>([]);
  const [selectedSize, setselectedSize] = useState("");
  const [selectedColour, setselectedColour] = useState("");
  const [selectedCat, setselectedCat] = useState<any | null>("");
  const [minPrice, setminPrice] = useState<any | null>(0);
  const [maxPrice, setmaxPrice] = useState<any | null>(999);
  const [selectedSub, setselectedSub] = useState<any>("");

  const [selectedSubCat, setselectedSubCat] = useState([]);
  const [dataCount, setcount] = useState(0);
  const [search, setsearch] = useState("");
  const [lopen, setlopen] = useState(true);

  const [mainDesc, setmainDesc] = useState<any>("");
  const [subDesc, setsubDesc] = useState("");
  const [filterSortValue, setFilterSortValue] = useState("");
  const [filterSortIndex, setfilterSortIndex] = useState(0);

  const [pageLimit, setpageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const [showModalQuickView, setShowModalQuickView] = useState(false);

  const [selectedPro, setselectedPro] = useState<any | null>([]);

  const [homeDistrict, sethomeDistrict] = useState("");
  const [homeCity, sethomeCity] = useState("");

  const [compProvider, setcompProvider] = useState(false);


  useEffect(() => {
    if (!(
      user?.firstName &&
      user?.lastName &&
      // cData?.country &&
      user?.email &&
      // cData?.about &&
      // cData?.homeAddress &&
      // cData?.homeCity &&
      // cData?.homeDistrict &&
      // cData?.homepostCode 

      // cData?.supplierCategory
      // cData?.businessName &&
      // cData?.establishedYear
      user?.contactNumber

    )) {
      setcompProvider(true);
    } else {
      setcompProvider(false);
    }
  }, [user])


  const getallCategory = () => {

    GetCleaningTypeContract()
      .then((response) => {
        console.log("category>>>>", response?.data);
        setcategories(response.data);
        // this.setState(
        //   {
        //     array: res.data.result,
        //     filter: res.data.result,
        //     showPages: m,
        //     showOff: true,
        //   },
        //   async () => {
        //     await this.getPaginationGroup(m);
        //   }
        // );
      })
      .catch(() => {
        // this.setState({
        //   array: [],
        //   filter: [],
        //   showPages: 1,
        //   showOff: false,
        // });
      });

  }

  useEffect(() => {
    getallCategory();

  }, [])

  useEffect(() => {

    const fetchData = async () => {
      const data = await getFilters();
      const data2 = await getItemProducts2();
    }


    fetchData();


  }, [selectedCat])

  useEffect(() => {
    if (allSubs.length !== 0) {
      const fetchData = async () => {
        const data2 = await getItemProducts();
      }

      fetchData();
    }

  }, [selectedSub, allSubs, filterSortValue, pageLimit, currentPage, selectedColour, selectedSize, minPrice, maxPrice, search, selectedPro, homeDistrict, homeCity])

  useEffect(() => {
    console.log("sub cats>>>>>", selectedSubCat)

  }, [selectedSubCat])

  const getFilters = async () => {

    const ob = {
      sort: {
        sortField: "productName",
        sort: "asc",
      },
      categories: selectedCat === "" ? JSON.stringify([]) : JSON.stringify([selectedCat]),
      distinct: "0",

    };
    // setlopen(true);

    await getAllProducts(ob).then((res) => {

      console.log("FFF>>", res)
      const allColors = _.uniqBy(res?.data?.result, function (e: { clolour: any; }) {
        return e.clolour;
      });
      var allColors2 = allColors?.filter(function (el: any) {
        return el.clolour !== "";
      });
      const allSizes = _.uniqBy(res?.data?.result, function (e: { size: any; }) {
        return e.size;
      });
      var sizeArr = allSizes?.filter(function (el: { size: string; }) {
        return el.size !== "";
      });
      const allPrice = _.uniqBy(res?.data?.result, function (e: { discountedprice: any; }) {
        return e.discountedprice;
      });
      const allTags = _.uniqBy(res?.data?.result, function (e: { tags: any; }) {
        return e.tags;
      });
      const allSubs = _.uniqBy(res?.data?.result, function (e: {
        subcatId: any;
        subCategory: any;
        subcatDesc: any;
      }) {
        return e.subCategory;
      });

      console.log("WWEDSD", allSubs)

      var subsArr = allSubs?.filter(function (el: { subCategory: null; }) {
        return el.subCategory !== null;
      });
      const myPrices = _.map(allPrice, "discountedprice");

      const Pricelist = _.sortBy(myPrices, [
        function (o: any) {
          return o;
        },
      ]);

      const mySizes = _.map(sizeArr, "size");
      const myColors = _.map(allColors2, "clolour");
      const myTags = _.map(allTags, "tags");
      const mySubs = _.map(subsArr, "subCategory");

      const updateMyColors = myColors?.map((item: any, index: any) => {
        return {
          id: index,
          name: item,
          status: false,
        };
      });

      const updateMySubs = subsArr.map((item, index) => {

        return {
          id: item.subcatId,
          name: item.subCategory,
          // description: item.subcatDesc,
        };



      });
      console.log("subs>>>>>", updateMySubs)
      setallSizes(mySizes);
      setallColours(myColors);
      settags(myTags);
      setallSubs(updateMySubs);

      let Id2: any = localStorage.getItem("sSub");
      setselectedSub(Id2 ? parseInt(Id2) : "");
      // this.setState({
      //   color: updateMyColors,
      //   size: mySizes,
      //   min: Pricelist[0],
      //   max: Pricelist[Pricelist.length - 1],
      //   range: {
      //     min: Pricelist[0],
      //     max: Pricelist[Pricelist.length - 1],
      //   },
      // });
    })
      .catch(() => {
        setlopen(false);
      });



  }

  const getItemProducts = async () => {
    let sort = {


      sortField: "productName",
      sort: "asc",

    }
    let latest = ""
    let featured = ""

    if (filterSortValue === "HighToLow") {

      sort = {


        sortField: "unitPrice",
        sort: "desc",

      }
    } else if (filterSortValue === "LowToHigh") {

      sort = {


        sortField: "unitPrice",
        sort: "asc",

      }
    } else if (filterSortValue === "latest") {
      latest = "1"
    } else if (filterSortValue === "featured") {
      featured = "1"
    } else {
      sort = {


        sortField: "productName",
        sort: "asc",

      }
      latest = ""
      featured = ""
    }





    // console.log(sortType)

    const obj = {

      sort: sort,
      categories: selectedCat === "" ? JSON.stringify([]) : JSON.stringify([selectedCat]),
      subId: selectedSub === "" ? JSON.stringify([]) : JSON.stringify([selectedSub]),
      search: search,
      latest: latest,
      featured: featured,
      pNo: currentPage.toString(),
      limit: pageLimit.toString(),
      color: selectedColour,
      size: selectedSize,
      pto: maxPrice,
      pfrom: minPrice,

    };
    console.log("><<<<<<<<<<<<", obj);
    try {
      await getContracts(
        {
          cleaningType: selectedCat === "" ? JSON.stringify([]) : JSON.stringify([selectedCat]),
          userId: "",
          title: search,
          // categories: selectedCat === "" ? JSON.stringify([]) : JSON.stringify([selectedCat]),
          fromHourlyRate: minPrice,
          toHourlyRate: maxPrice,
          page: currentPage.toString(),
          limit: pageLimit.toString(),
          state: homeDistrict,
          suburb: homeCity,
          sortValue: filterSortValue === "LowToHigh" ? "asc" : filterSortValue === "HighToLow" ? "desc" : filterSortValue === "latest" ? "desc" : filterSortValue === "older" ? "asc" : "desc",
          sortField: filterSortValue === "LowToHigh" ? "title" : filterSortValue === "HighToLow" ? "title" : filterSortValue === "latest" ? "createdAt" : filterSortValue === "older" ? "createdAt" : "id",
          isActive: "1"
        }
      )
        .then((response) => {
          // setlopen(false);
          console.log(">>>>>>>>>>>>>>>>>>", response?.data);

          let m =
            Math.ceil(parseFloat(response.data.count[0].pages)) === 0
              ? 1
              : Math.ceil(parseFloat(response.data.count[0].pages));

          setnProducts(response.data.result);
          setcount(response.data.count[0].count);
          // this.setState(
          //   {
          //     array: res.data.result,
          //     filter: res.data.result,
          //     showPages: m,
          //     showOff: true,
          //   },
          //   async () => {
          //     await this.getPaginationGroup(m);
          //   }
          // );
        })
        .catch(() => {
          setnProducts([]);
          setcount(0);
          // setlopen(false);
          // this.setState({
          //   array: [],
          //   filter: [],
          //   showPages: 1,
          //   showOff: false,
          // });
        });
    } catch (error) {
      console.log("T&C ", error);
    }
  }

  const getItemProducts2 = async () => {
    let sort = {


      sortField: "productName",
      sort: "asc",

    }
    let latest = ""
    let featured = ""

    if (filterSortValue === "HighToLow") {

      sort = {


        sortField: "unitPrice",
        sort: "desc",

      }
    } else if (filterSortValue === "LowToHigh") {

      sort = {


        sortField: "unitPrice",
        sort: "asc",

      }
    } else if (filterSortValue === "latest") {
      latest = "1"
    } else if (filterSortValue === "featured") {
      featured = "1"
    } else {
      sort = {


        sortField: "productName",
        sort: "asc",

      }
      latest = ""
      featured = ""
    }





    // console.log(sortType)

    const obj = {

      sort: sort,
      categories: selectedCat === "" ? JSON.stringify([]) : JSON.stringify([selectedCat]),
      subId: selectedSub === "" ? JSON.stringify([]) : JSON.stringify([selectedSub]),
      search: search,
      latest: latest,
      featured: featured,
      pNo: currentPage.toString(),
      limit: pageLimit.toString(),
      color: selectedColour,
      size: selectedSize,
      pto: maxPrice,
      pfrom: minPrice,

    };
    console.log("><<<<<<<<<<<<", obj);
    try {
      // setlopen(true);
      await getContracts(
        {
          cleaningType: selectedCat === "" ? JSON.stringify([]) : JSON.stringify([selectedCat]),
          userId: "",
          title: search,
          // categories: selectedCat === "" ? JSON.stringify([]) : JSON.stringify([selectedCat]),
          fromHourlyRate: minPrice,
          toHourlyRate: maxPrice,
          page: currentPage.toString(),
          limit: pageLimit.toString(),
          state: homeDistrict,
          suburb: homeCity,
          sortValue: filterSortValue === "LowToHigh" ? "asc" : filterSortValue === "HighToLow" ? "desc" : filterSortValue === "latest" ? "desc" : filterSortValue === "older" ? "asc" : "desc",
          sortField: filterSortValue === "LowToHigh" ? "title" : filterSortValue === "HighToLow" ? "title" : filterSortValue === "latest" ? "createdAt" : filterSortValue === "older" ? "createdAt" : "id",
          isActive: "1"
        }
      )
        .then((response) => {
          setlopen(false);
          console.log(">>>>>>>>>>>>>>>>>>", response?.data);

          let m =
            Math.ceil(parseFloat(response.data.count[0].pages)) === 0
              ? 1
              : Math.ceil(parseFloat(response.data.count[0].pages));

          setnProducts(response.data.result);
          setcount(response.data.count[0].count);
          // this.setState(
          //   {
          //     array: res.data.result,
          //     filter: res.data.result,
          //     showPages: m,
          //     showOff: true,
          //   },
          //   async () => {
          //     await this.getPaginationGroup(m);
          //   }
          // );
        })
        .catch(() => {
          setnProducts([]);
          setcount(0);
          setlopen(false);
          // this.setState({
          //   array: [],
          //   filter: [],
          //   showPages: 1,
          //   showOff: false,
          // });
        });
    } catch (error) {
      console.log("T&C ", error);
    }
  }


  useEffect(() => {
    console.log("selected cat>>>>", selectedCat)
  }, [selectedCat])

  useEffect(() => {
    console.log("param>>>", localStorage.getItem("sMain"));

    let Id: any = localStorage.getItem("sMain");
    let Id2: any = localStorage.getItem("sSub");




    if (((Id && Id !== undefined)
      // || (Id2 && Id2 !== undefined)
    ) && (categories.length !== 0 && nProducts.length !== 0)) {
      setselectedCat(parseInt(Id));
      // setselectedSub(Id2 ? parseInt(Id2) : "");


      Categories()
        .then((response) => {

          var subsArr = response?.data?.filter(function (el: { mainId: number; }) {

            return el.mainId === parseInt(Id!);
          });

          console.log("MAINNNNNNNNN", subsArr)
          setmainDesc(subsArr[0])

        })
        .catch(() => {

        });





    }

    // return () => {
    //   localStorage.removeItem("sMain");
    // };

  }, [categories, nProducts])

  useEffect(() => {

    return () => {
      localStorage.removeItem("sMain");
      localStorage.removeItem("sSub");
    }
  }, [])






  return (
    <>
      <ModalQuickView
        show={showModalQuickView}
        onCloseModalQuickView={() => setShowModalQuickView(false)}
        selectedJob={""}
      />
      <div
        className={`nc-PageCollection2 ${className}`}
        data-nc-id="PageCollection2"
      >
        <LoadingSpinner open={lopen} />
        <Helmet>
          <title>Contracts || Mangalya.lk</title>
        </Helmet>

        <div className="w-full h-[40px] md:h-[45px] xl:h-[35px] 2xl:h-[55px] bg-cover bg-center bg-[#002930] relative z-[1]"
        // style={{
        //   backgroundImage: `url(${cover})`
        // }}
        >
          <div className="w-full h-full flex justify-center items-center">
            <div className="" >
              {/* <h2 className="nc-SectionHero2Item__heading font-semibold text-xl xl:text-xl 2xl:text-3xl !leading-[114%] text-slate-50 flex justify-center">
              Service Providers
            </h2> */}
              <span className="nc-SectionHero2Item__subheading block text-xs sm:text-sm text-slate-100 font-medium flex justify-center max-w-3xl text-center px-3 lg:px-0">
                New to the platform ? &nbsp; <NavLink to={"/signup"} ><span className="text-[#F1A700]">Open your account for FREE</span></NavLink>
              </span>
              {/* <div className="w-full flex items-center justify-center">
              <button
                className={
                  `ttnc-ButtonCircle rounded-full flex items-center justify-center !leading-none disabled:bg-opacity-70 
        w-3xl px-6 h-9 font-medium mt-2 cursor-pointer hover:bg-slate-800 w-2xl bg-white text-slate-900 hover:text-slate-50 mt-4`}



              >

                <span className="block  text-xs font-medium">
                  Create Page
                </span>

              </button>

            </div> */}


            </div>

          </div>



        </div>

        <div className="w-full h-[140px] md:h-[145px] xl:h-[155px] 2xl:h-[175px] bg-cover bg-center bg-[#F4F4F4] relative z-[1]"
        // style={{
        //   backgroundImage: `url(${cover})`
        // }}
        >
          <div className="w-full h-full flex justify-center items-center px-4">
            <div className="" >
              <h2 className="nc-SectionHero2Item__heading font-black text-xl text-xl xl:text-xl 2xl:text-3xl !leading-[114%] flex justify-center text-center">
                Explore Open Cleaning Contracts in the Market
              </h2>
              {/* <span className="nc-SectionHero2Item__subheading block text-sm md:text-sm font-medium flex justify-center mt-2 max-w-3xl text-center px-3 lg:px-0">
              Start your job search now
            </span> */}
              <div className="w-full flex items-center justify-center">


                <button
                  className={
                    `ttnc-ButtonCircle rounded-full flex items-center justify-center !leading-none disabled:bg-opacity-70 
    w-3xl px-6 h-9 font-medium mt-2 cursor-pointer hover:bg-slate-800 w-2xl bg-[#002930] text-slate-100 hover:text-slate-50 mt-4`}



                  onClick={(e) => {

                    if (compProvider && user && user.userType === "service seeker") {
                      history.push("/profile");
                      addToast("Please complete the profile to continue", "warning");
                      return;
                    }
                    // setShowModalQuickView(true);
                    if (user && user.userType === "service seeker") {
                      setShowModalQuickView(true);
                    } else {
                      history.push("/login");
                      addToast("Login as a service seeker to continue", "warning");
                    }
                  }}


                >

                  <span className="block  text-xs font-medium">
                    List your contract for FREE
                  </span>
                </button>




              </div>


            </div>

          </div>



        </div>



        <div className="container lg:py-16 lg:pb-0 lg:pt-14 space-y-16 sm:space-y-20 lg:space-y-28">
          <div className="space-y-10 lg:space-y-14">
            {/* HEADING */}
            {/* <div className="w-full">
            <h2 className="block text-2xl sm:text-4xl lg:text-5xl font-bold">
             
              Grow Your Career
            </h2>
            <div className="flex">
              <span className="block mt-4 dark:text-neutral-400 text-sm sm:text-base text-justify">

                Explore Exciting Job Opportunities in the Agriculture and Farming Industry&nbsp;

              </span>
              <span className="mt-4 text-[#2d867b]">
                Worldwide.
              </span>
            </div>
            <div className="flex w-full mt-4">
              <button
                className={
                  `ttnc-ButtonCircle rounded-full flex items-center justify-center !leading-none disabled:bg-opacity-70 
        w-[150px] px-6 h-9 text-slate-50 font-medium mt-2 cursor-pointer border border-[#2d867b] bg-[#2d867b] text-slate-100`}

                onClick={() => {
                  setShowModalQuickView(true);
                }}

              >

                <span className="block  text-sm font-bold ">
                  Create Job
                </span>

              </button>
            </div>
          </div> */}

            {/* <hr className="border border-2" /> */}
            <main>
              {/* LOOP ITEMS */}
              <div className="flex flex-col lg:flex-row">
                {/* <div className="lg:w-1/3 xl:w-1/4 pr-4">
                <SidebarFilters
                  filterType={"job"}
                  homeDistrict={homeDistrict}
                  homeCity={homeCity}
                  sethomeDistrict={sethomeDistrict}
                  sethomeCity={sethomeCity}
                  selectedPro={selectedPro}
                  setselectedPro={setselectedPro}
                  categories={categories}
                  setSelectedcat={setselectedCat}
                  selectedCat={selectedCat}
                  allSubs={allSubs}
                  setselectedSub={setselectedSub}
                  selectedSub={selectedSub}
                  allSizes={allSizes}
                  selectedSize={selectedSize}
                  setselectedSize={setselectedSize}
                  allColours={allColours}
                  selectedColour={selectedColour}
                  setselectedColour={setselectedColour}
                  setminPrice={setminPrice}
                  minPrice={minPrice}
                  setmaxPrice={setmaxPrice}
                  maxPrice={maxPrice}
                  filterSortValue={filterSortValue}
                  setFilterSortValue={setFilterSortValue}
                  setCurrentPage={setCurrentPage}
                  setmainDesc={setmainDesc}
                  setsearch={setsearch}
                  search={search}
                />
              </div> */}
                {/* <div className="flex-shrink-0 mb-4 lg:mb-0 lg:mx-4 border-t lg:border-t-0"></div> */}
                <div className="flex-1 ">
                  <div className="">
                    <div className="relative flex flex-col pb-8">
                      <div className="w-full flex justify-between">
                        {/* <Input
                        type="text"
                        placeholder="Search Name"
                        className="mt-1 max-w-sm"
                        onChange={(e: any) => {
                          setsearch(e.target.value);

                          // seterrfirstName(false);
                        }}
                        value={search}
                      />
                      <Select className="mt-1.5 w-5/12 sm:w-3/12 mb-6"
                        onChange={(e) => {
                          setFilterSortValue(e.target.value);

                        }}
                        value={filterSortValue}
                      >
                        <option value={""}>Sort Order</option>
                        <option value="">None</option>
                      
                        <option value="LowToHigh">Hourly Rate Low - High</option>
                        <option value="HighToLow">Hourly Rate High - Low</option>
                        <option value="Newest">Newest First</option>


                       
                      </Select> */}
                        <TabFilters
                          filterType={"contract"}
                          homeDistrict={homeDistrict}
                          homeCity={homeCity}
                          sethomeDistrict={sethomeDistrict}
                          sethomeCity={sethomeCity}
                          selectedPro={selectedPro}
                          setselectedPro={setselectedPro}
                          categories={categories}
                          setSelectedcat={setselectedCat}
                          selectedCat={selectedCat}
                          allSubs={allSubs}
                          setselectedSub={setselectedSub}
                          selectedSub={selectedSub}
                          allSizes={allSizes}
                          selectedSize={selectedSize}
                          setselectedSize={setselectedSize}
                          allColours={allColours}
                          selectedColour={selectedColour}
                          setselectedColour={setselectedColour}
                          setminPrice={setminPrice}
                          minPrice={minPrice}
                          setmaxPrice={setmaxPrice}
                          maxPrice={maxPrice}
                          filterSortValue={filterSortValue}
                          setFilterSortValue={setFilterSortValue}
                          setCurrentPage={setCurrentPage}
                          setmainDesc={setmainDesc}
                          setsearch={setsearch}
                          search={search}
                        />
                      </div>

                      <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-4 lg:gap-y-10">

                        {nProducts?.length > 0 && nProducts?.map((item, index) => (
                          // <ProductCardNew data2={item} key={index} />
                          <ContractCard collection={true} data={item} />
                        ))}
                        {nProducts.length === 0 && <span className="block mt-4 text-neutral-500 dark:text-neutral-400 text-sm sm:text-base">
                          No contracts found.
                        </span>}

                      </div>

                    </div>

                  </div>
                  {/* PAGINATION */}
                  {
                    dataCount > 0 &&

                    <div className="flex flex-col mt-12 lg:mt-16 space-y-5 xl:space-y-0 xl:space-x-3 xl:flex-row xl:justify-between xl:items-center">
                      {/* <Pagination
                      pageLimit={pageLimit}
                      dataCount={dataCount}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    /> */}
                      <ButtonPrimary
                        // loading
                        onClick={() => {

                          setpageLimit(pageLimit + 20);
                        }}
                      >Show me more</ButtonPrimary>
                    </div>
                  }
                </div>
              </div>

            </main>
          </div>

          {/* === SECTION 5 === */}
          {/* <hr className="border-slate-200 dark:border-slate-700" />

        <SectionSliderCollections /> */}
          <hr className="border-slate-200 dark:border-slate-700" />

          {/* SUBCRIBES */}

        </div>
        <SectionPromo1 />

        {/* <ModalJob
          show={showModalQuickView}
          onCloseModalQuickView={() => setShowModalQuickView(false)}
        /> */}
      </div>
    </>
  );
};

export default PageCollection2;
